module.exports = __webpack_public_path__ + "static/media/fff-logo-r.d9f4cff2.svg";